import { render, staticRenderFns } from "./Pendingnamelist.vue?vue&type=template&id=782ae3a2&scoped=true"
import script from "./Pendingnamelist.vue?vue&type=script&lang=js"
export * from "./Pendingnamelist.vue?vue&type=script&lang=js"
import style0 from "./Pendingnamelist.vue?vue&type=style&index=0&id=782ae3a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782ae3a2",
  null
  
)

export default component.exports